/**
 * J&T Express Address Cascade for Shopify (Philippines)
 * =====================================================
 * Province -> City/Municipality -> Barangay/Town
 *
 * Data source: jt-addresses.json (uploaded to Shopify Files)
 * Config: window.JT_CONFIG (set in jt-address-cascade.liquid)
 *
 * How it works:
 * 1. Loads JSON address data from Shopify Files CDN
 * 2. Finds Shopify address form fields (province, city, address1)
 * 3. Replaces province & city inputs with <select> dropdowns
 * 4. Inserts a barangay/town <select> before the address field
 * 5. Three-level cascade: select province -> cities load -> select city -> barangays load
 * 6. On form submit, selected barangay is prepended to address1
 */

(function () {
  'use strict';

  var CONFIG = {
    dataUrl: (window.JT_CONFIG && window.JT_CONFIG.dataUrl) || '',
    selectors: {
      province: (window.JT_CONFIG && window.JT_CONFIG.selectors && window.JT_CONFIG.selectors.province) || 'input[name*="province"]',
      city: (window.JT_CONFIG && window.JT_CONFIG.selectors && window.JT_CONFIG.selectors.city) || 'input[name*="city"]',
      address1: (window.JT_CONFIG && window.JT_CONFIG.selectors && window.JT_CONFIG.selectors.address1) || 'input[name*="address1"]',
      form: 'form'
    },
    placeholders: {
      province: 'Select Province',
      city: 'Select City/Municipality',
      town: 'Select Barangay/Town'
    }
  };

  var addressData = null;
  var processedForms = [];

  function injectStyles() {
    if (document.getElementById('jt-cascade-styles')) return;
    var style = document.createElement('style');
    style.id = 'jt-cascade-styles';
    style.textContent = [
      '.jt-cascade-wrap{margin-bottom:1rem;}',
      '.jt-cascade-wrap:last-child{margin-bottom:0;}',
      '.jt-cascade-label{display:block;font-size:1.3rem;line-height:1;margin-bottom:.6rem;color:var(--color-foreground, #333);}',
      '.jt-cascade-select{width:100%;padding:1rem 1.2rem;border:.1rem solid rgba(var(--color-foreground, 0,0,0),.2);border-radius:.4rem;font-size:1.6rem;background-color:var(--color-background, #fff);color:var(--color-foreground, #333);cursor:pointer;appearance:none;-webkit-appearance:none;-moz-appearance:none;',
      'background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 16 16\'%3E%3Cpath d=\'M8 11L3 6h10z\' fill=\'%23888\'/%3E%3C/svg%3E");',
      'background-repeat:no-repeat;background-position:right 1.2rem center;background-size:1.2rem;}',
      '.jt-cascade-select:focus{border-color:var(--color-foreground, #333);outline:none;}',
      '.jt-cascade-select:disabled{background-color:#f5f5f5;cursor:not-allowed;opacity:.6;}',
      '.jt-cascade-select option{color:#333;background:#fff;}'
    ].join('');
    document.head.appendChild(style);
  }

  function loadData(callback) {
    if (addressData) { callback(null, addressData); return; }
    if (!CONFIG.dataUrl) { callback(new Error('No data URL configured')); return; }
    fetch(CONFIG.dataUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) { addressData = data; callback(null, data); })
      .catch(function (err) { callback(err); });
  }

  function createSelect(placeholder) {
    var sel = document.createElement('select');
    sel.className = 'jt-cascade-select';

    var def = document.createElement('option');
    def.value = '';
    def.textContent = placeholder;
    def.disabled = true;
    def.selected = true;
    sel.appendChild(def);

    return sel;
  }

  function fillSelect(sel, options) {
    while (sel.options.length > 1) {
      sel.remove(1);
    }
    options.forEach(function (text) {
      var opt = document.createElement('option');
      opt.value = text;
      opt.textContent = text;
      sel.appendChild(opt);
    });
  }

  function clearSelect(sel, placeholder) {
    sel.innerHTML = '';
    var opt = document.createElement('option');
    opt.value = '';
    opt.textContent = placeholder;
    opt.disabled = true;
    opt.selected = true;
    sel.appendChild(opt);
  }

  function getCities(province) {
    if (!addressData[province] || !addressData[province].cities) return [];
    return Object.keys(addressData[province].cities).sort();
  }

  function getTowns(province, city) {
    if (!addressData[province] || !addressData[province].cities[city]) return [];
    return addressData[province].cities[city].slice();
  }

  function getRegion(province) {
    if (!addressData[province]) return '';
    return addressData[province].region || '';
  }

  function wrapSelect(sel, labelText) {
    var wrap = document.createElement('div');
    wrap.className = 'jt-cascade-wrap';

    var label = document.createElement('label');
    label.className = 'jt-cascade-label';
    label.textContent = labelText;
    wrap.appendChild(label);
    wrap.appendChild(sel);
    return wrap;
  }

  function syncToInput(selectEl, inputEl) {
    selectEl.addEventListener('change', function () {
      inputEl.value = selectEl.value;
      inputEl.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function initForm(form) {
    if (processedForms.indexOf(form) !== -1) return;
    if (form.classList && form.classList.contains('jt-cascade-initialized')) return;

    var provinceInput = form.querySelector(CONFIG.selectors.province);
    var cityInput = form.querySelector(CONFIG.selectors.city);
    var addressInput = form.querySelector(CONFIG.selectors.address1);

    if (!provinceInput || !cityInput) return;

    loadData(function (err) {
      if (err) { console.error('[JT Cascade] Data load failed:', err); return; }
      if (!addressData) return;

      form.classList.add('jt-cascade-initialized');
      processedForms.push(form);

      var selectedTown = '';
      var prevTown = '';

      // --- Province select ---
      var provSelect = createSelect(CONFIG.placeholders.province);
      var provinces = Object.keys(addressData).sort();
      fillSelect(provSelect, provinces);

      var provWrap = wrapSelect(provSelect, 'Province');
      provinceInput.style.display = 'none';
      provinceInput.parentNode.insertBefore(provWrap, provinceInput.nextSibling);
      syncToInput(provSelect, provinceInput);

      // --- City select ---
      var citySelect = createSelect(CONFIG.placeholders.city);
      citySelect.disabled = true;

      var cityWrap = wrapSelect(citySelect, 'City / Municipality');
      cityInput.style.display = 'none';
      cityInput.parentNode.insertBefore(cityWrap, cityInput.nextSibling);
      syncToInput(citySelect, cityInput);

      // --- Town select (before address field) ---
      var townSelect = createSelect(CONFIG.placeholders.town);
      townSelect.disabled = true;

      var townWrap = wrapSelect(townSelect, 'Barangay / Town');

      if (addressInput) {
        addressInput.parentNode.insertBefore(townWrap, addressInput.parentNode.firstChild);
      }

      townSelect.addEventListener('change', function () {
        selectedTown = townSelect.value;
      });

      // --- Cascade logic ---
      provSelect.addEventListener('change', function () {
        var prov = provSelect.value;
        cityInput.value = '';
        selectedTown = '';
        prevTown = '';

        clearSelect(citySelect, CONFIG.placeholders.city);
        clearSelect(townSelect, CONFIG.placeholders.town);

        if (prov) {
          var cities = getCities(prov);
          fillSelect(citySelect, cities);
          citySelect.disabled = false;
        } else {
          citySelect.disabled = true;
          townSelect.disabled = true;
        }
      });

      citySelect.addEventListener('change', function () {
        var prov = provSelect.value;
        var city = citySelect.value;
        selectedTown = '';
        prevTown = '';

        clearSelect(townSelect, CONFIG.placeholders.town);

        if (prov && city) {
          var towns = getTowns(prov, city);
          fillSelect(townSelect, towns);
          townSelect.disabled = false;
        } else {
          townSelect.disabled = true;
        }
      });

      // --- On form submit, prepend barangay to address1 ---
      form.addEventListener('submit', function () {
        if (!addressInput) return;

        var currentVal = addressInput.value;

        // Remove previous town prefix if any
        if (prevTown && currentVal.indexOf(prevTown + ', ') === 0) {
          currentVal = currentVal.substring(prevTown.length + 2);
        }

        // Add new town prefix
        if (selectedTown) {
          if (currentVal) {
            addressInput.value = selectedTown + ', ' + currentVal;
          } else {
            addressInput.value = selectedTown;
          }
          prevTown = selectedTown;
        } else {
          addressInput.value = currentVal;
          prevTown = '';
        }
      });

      // Try to restore existing values
      if (provinceInput.value) {
        for (var i = 0; i < provSelect.options.length; i++) {
          if (provSelect.options[i].value === provinceInput.value) {
            provSelect.selectedIndex = i;
            provSelect.dispatchEvent(new Event('change'));
            break;
          }
        }
        if (cityInput.value) {
          for (var j = 0; j < citySelect.options.length; j++) {
            if (citySelect.options[j].value === cityInput.value) {
              citySelect.selectedIndex = j;
              citySelect.dispatchEvent(new Event('change'));
              break;
            }
          }
        }
      }
    });
  }

  function init() {
    injectStyles();

    var forms = document.querySelectorAll(CONFIG.selectors.form);
    forms.forEach(function (form) {
      if (form.querySelector(CONFIG.selectors.province)) {
        initForm(form);
      }
    });

    // Watch for dynamically loaded forms
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var forms = node.querySelectorAll ? node.querySelectorAll(CONFIG.selectors.form) : [];
          if (forms.length === 0 && node.tagName === 'FORM') {
            forms = [node];
          }
          forms.forEach(function (form) {
            if (form.querySelector(CONFIG.selectors.province)) {
              setTimeout(function () { initForm(form); }, 100);
            }
          });
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
